import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useGetUserQuery } from '../../../redux/api'

const AuthSuccess: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data: user, isSuccess } = useGetUserQuery(undefined)

  useEffect(() => {
    // If user data is successfully loaded, return to the page the guest came
    // from (stashed before the OAuth round-trip), defaulting to home.
    if (isSuccess && user) {
      const redirect = sessionStorage.getItem('auth_redirect') || '/'
      sessionStorage.removeItem('auth_redirect')
      navigate(redirect)
    }

    // If there's an error or no user after 3 seconds, redirect to login
    const timeout = setTimeout(() => {
      if (!user) {
        navigate('/login')
      }
    }, 3000)

    return () => clearTimeout(timeout)
  }, [isSuccess, user, navigate])

  return (
    // the system's card on the page colour; the status is announced
    <div className="flex flex-col items-center justify-center min-h-screen supports-[height:100dvh]:min-h-dvh px-4 bg-page">
      <div
        role="status"
        className="flex flex-col items-center gap-3 w-full max-w-[26rem] p-6 md:p-8 bg-surface rounded-2xl shadow-card text-center"
      >
        <h1 className="m-0 text-[1.375rem] font-black leading-7 text-ink">
          {t('auth_success.title')}
        </h1>
        <p className="m-0 text-base leading-6 text-ink">{t('auth_success.text')}</p>
        <div
          aria-hidden="true"
          className="animate-spin rounded-full h-10 w-10 border-2 border-solid border-brand-soft border-t-brand my-2"
        />
        <p className="m-0 text-sm leading-5 text-ink-2">{t('auth_success.redirecting')}</p>
      </div>
    </div>
  )
}

export default AuthSuccess
